import React from "react";
import Heading from "../../components/heading/Heading";

const HeadingTitle = ({ text }) => {
  return (
    <Heading level={1} className="text-gray-900 text-6xl text-center font-bold mb-4">
      {text}
    </Heading>
  );
};

export default HeadingTitle;
